export const build = { date:"2026-04-15.2227", stage:"alpha" }
